package de.emgress.baskets.modules.schedule

import androidx.compose.runtime.Composable
import de.emgress.baskets.core.styles.Styles
import de.emgress.baskets.modules.components.CountdownComponent
import kotlinx.datetime.DateTimePeriod
import org.jetbrains.compose.web.dom.Div

@Composable
fun Countdown(
    periodeToNextGame: DateTimePeriod,
) {
    periodeToNextGame.let {
        Div({
            classes(Styles.cssClasses.rowCentered)
        }) {
            if (it.months > 0) {
                CountdownComponent(if (it.months == 1) "Monat" else "Monate", it.months)
            }
            CountdownComponent(if (it.days == 1) "Tag" else "Tage", it.days)
            CountdownComponent(if (it.hours == 1) "Stunde" else "Stunden", it.hours)
            CountdownComponent(if (it.minutes == 1) "Minute" else "Minuten", it.minutes)
            CountdownComponent(if (it.seconds == 1) "Sekunde" else "Sekunden", it.seconds)
        }
    }
}